import { Button } from '@material-ui/core';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ActionTypes from '../../../../actions/types';
import { useHistory } from 'react-router-dom';

const SearchAndGo = ({
  styles,
  changeTicker,
  keyPress,
  refreshOpenInterest,
}) => {
  const { appReducer } = useSelector((state) => state);
  let history = useHistory();
  const dispatch = useDispatch();

  const setStateAction = (newState) =>
    dispatch({
      type: ActionTypes.SET_OPEN_INTREST,
      payload: newState,
    });
  return (
    <div>
      <div style={styles.topBar}>
        <div style={{ display: 'flex', marginLeft: '20px' }}>
          <input
            name="ticker"
            style={styles.tickerInputMobile}
            value={appReducer.ticker}
            placeholder="Stock Ticker"
            onChange={(event) => changeTicker(event)}
            onKeyDown={(event) => keyPress(event)}
          />
          <Button
            variant="contained"
            style={styles.goButtonMobile}
          
            onClick={() => {
              setStateAction({
                localTicker: appReducer.ticker,
                from: '-',
                to: '-',
                fromValue: 0,
                toValue: 99999999,
                percent: null,
                putsLimit: 99999999,
                callsLimit: 99999999,
                dates: [],
                showChart: false,
                putsChartData: [],
                callsChartData: [],
                modalStrikes: [],
                step: 1,
                max: 1,
              });
              refreshOpenInterest(appReducer.ticker);
              history.push(`/openinterest/${appReducer.ticker}`);
              window.scroll(0, 0);
            }}
          >
            Go
          </Button>
        </div>
      </div>
      <div style={styles.mobileTxExp}>
        Select a Strike Price Range & Choose a Top Percentile
      </div>
    </div>
  );
};
export default SearchAndGo;



// WEBPACK FOOTER //
// ./src/Pages/OpenInterest/components/mobileViewComponents/searchandGo.jsx